/* eslint-disable no-unused-vars */
/** @module Auth0PreLoginHandlerVerifyEmail */
/* eslint-disable import/extensions */
import Auth0PreLoginHandlerBase from '../auth0-pre-login-handler-base.mst.mjs';
import { Auth0VerifyEmailPageHelper } from '../../../pages/auth0-verify-email-page-helper.mst.mjs';

class Auth0PreLoginHandlerVerifyEmail extends Auth0PreLoginHandlerBase {
  _shouldHandleSync = () => {
    return this._flow === 'verifyEmail';
  };

  /**
   * @inheritdoc
   */
  async shouldHandle() {
    return Promise.resolve(this._shouldHandleSync());
  }

  /**
   * @inheritdoc
   */
  async run(viewOptions = {}) {
    new Auth0VerifyEmailPageHelper({
      name: 'Auth0VerifyEmailPageHelper',
      tenantOrDomain: this._tenant.id,
      clientId: this._clientId,
      appLoginUrl: this._appLoginUrl,
      whiteLabelOptions: this._whiteLabelOptions,
      ...viewOptions,
    }).render();
    // mark this request as handled
    return true;
  }
}

export default Auth0PreLoginHandlerVerifyEmail;
